<template>
  <header
    ref="header"
    :class="{
      'header_full': active == true,
      'header_search': searchActive == true,
      'header_breadcrumbed': breadcrumbs == true,
    }"
  >
    <slot
      :toggleSearch="toggleSearch"
      :toggleDrawer="toggleDrawer"
      :drawerActive="drawerActive"
      :toggleSubmenu="toggleSubmenu"
      :activeSubmenu="activeSubmenu"
    />
  </header>
</template>

<script>
import { TweenMax, Power4 } from 'gsap'

export default {
  data() {
    return {
      active: true,
      searchActive: false,
      drawerActive: false,
      breadcrumbs: false,
      activeSubmenu: undefined,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)

    TweenMax.staggerTo('.header-logo-main__tween', 0.4, {
      opacity: 1,
      ease: Power4.easeIn,
    },
    0.05)

    TweenMax.staggerFrom('.header-menu__item', 0.4, {
      delay: 0.8,
      opacity: 0,
      ease: Power4.easeIn,
    },
    0.05)

    if (this.$refs.header.getElementsByClassName('header-breadcrumbs').length > 0) {
      this.breadcrumbs = true
    }
  },
  methods: {
    handleScroll() {
      this.active = !(window.scrollY > 500)
    },
    toggleSearch() {
      this.searchActive = !this.searchActive
    },
    toggleDrawer() {
      this.drawerActive = !this.drawerActive

      if (this.drawerActive) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    toggleSubmenu(a) {
      this.activeSubmenu = this.activeSubmenu === a ? undefined : a
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TheHeader.vue